export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  imageSeq: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'xinshou-ru-men-gonglue',
    title: '重生萝莉岛新手入门完全攻略',
    excerpt: '刚来到重生萝莉岛不知道从哪里开始？这篇新手攻略将带你从零开始，快速掌握岛屿生存与冒险的基础技巧。',
    content: `<h2>初到重生萝莉岛</h2>
<p>当你第一次踏上重生萝莉岛的土地时，眼前展现的是一片充满神秘色彩的奇幻世界。郁郁葱葱的森林、晶莹剔透的湖泊、以及远处若隐若现的古老遗迹，每一处都散发着令人心动的魅力。</p>
<p>作为重生者，你将在岛屿的<strong>启程之村</strong>开始你的冒险。这里是所有冒险者的起点，你可以在这里结识伙伴、接受委托任务，为接下来的冒险做好准备。</p>

<h2>基础生存技巧</h2>
<p>在重生萝莉岛上，掌握基础的生存技巧至关重要。以下是你需要优先了解的几个方面：</p>

<h3>1. 收集资源</h3>
<p>岛屿上分布着丰富的资源点。木材可以从森林区域获取，矿石则分布在岛屿的北部山脉地带。记得带上你的<strong>采集工具</strong>，不同品质的工具会影响采集效率。</p>

<h3>2. 战斗系统</h3>
<p>重生萝莉岛采用独特的<strong>重生战斗系统</strong>。每次战斗失败后，你并不会真正死亡，而是会回到最近的存档点，并保留部分经验值。这让每一次战斗都充满策略性——你可以在失败中学习敌人的攻击模式，制定更好的应对策略。</p>

<h3>3. 伙伴羁绊</h3>
<p>在冒险过程中，你会遇到各种可爱的萝莉伙伴。通过与她们互动、完成专属任务，可以提升<strong>羁绊等级</strong>。羁绊等级越高，伙伴在战斗中的表现就越出色，甚至能解锁隐藏的合体技能。</p>

<h2>推荐升级路线</h2>
<p>对于新手玩家，建议按照以下路线推进：启程之村 → 翠绿森林 → 星湖遗迹 → 古都废墟。这条路线难度递进合理，沿途还能收集到不少有用的装备和道具。</p>

<h2>常见问题</h2>
<p><strong>Q：如何快速提升等级？</strong><br/>A：建议优先完成每日委托任务，同时不要忽略地图上的隐藏宝箱，它们往往包含大量经验值道具。</p>

<p><strong>Q：哪个伙伴最适合新手？</strong><br/>A：推荐优先培养<strong>小樱</strong>，她的治疗技能在前期非常实用，能大幅提升你的续航能力。</p>`,
    category: 'gonglue',
    categoryName: '攻略指南',
    imageSeq: 'article-xinshou',
    author: '岛主小助手',
    date: '2026-07-28',
    readTime: '8分钟',
    tags: ['新手攻略', '入门指南', '基础技巧', '伙伴推荐'],
  },
  {
    slug: 'shenmi-daoju-zhong-sheng-zhi-mi',
    title: '深度解析：重生萝莉岛的神秘重生机制',
    excerpt: '为什么在重生萝莉岛上可以不断重生？这背后隐藏着怎样的世界观设定？本文为你揭开重生机制的秘密。',
    content: `<h2>重生的起源</h2>
<p>在重生萝莉岛的古老传说中，岛屿本身是一个巨大的<strong>生命能量聚合体</strong>。据说在很久很久以前，一位强大的古代魔法师将整个岛屿与生命之泉融为一体，使得岛屿上的所有生灵都获得了重生的祝福。</p>

<h2>重生机制详解</h2>
<p>重生萝莉岛的重生并非简单的"复活"。每一次重生都是一次<strong>灵魂的重新编织</strong>。当你"死亡"时，你的灵魂会被岛屿的生命能量捕获，并在最近的<strong>生命石碑</strong>处重新凝聚。</p>

<h3>重生的代价</h3>
<p>虽然重生让你免于真正的死亡，但每次重生都需要消耗一定量的<strong>灵魂能量</strong>。如果灵魂能量耗尽，你将暂时无法重生，需要通过在岛上完成任务或收集特定道具来恢复。</p>

<h3>重生的进化</h3>
<p>有趣的是，随着重生次数的增加，你的角色会逐渐获得<strong>特殊能力</strong>。有些玩家报告说，在经历了100次重生后，他们的角色获得了预知敌人攻击的能力。这被称为"重生进化论"，是岛上最热门的研究课题之一。</p>

<h2>剧情中的重生隐喻</h2>
<p>从叙事角度来看，重生萝莉岛的重生机制是对人生的深刻隐喻。每一次失败都不是终点，而是新的开始。这也是为什么这款作品能引起如此多玩家共鸣的原因——它告诉我们，无论跌倒多少次，只要不放弃，就能继续前行。</p>`,
    category: 'juqing',
    categoryName: '剧情解析',
    imageSeq: 'article-zhongsheng',
    author: '剧情研究员莉莉',
    date: '2026-07-25',
    readTime: '10分钟',
    tags: ['重生机制', '世界观', '剧情分析', '隐藏设定'],
  },
  {
    slug: 'renqi-juese-xiaoying-xiangjie',
    title: '人气角色详解：治愈天使小樱的完整图鉴',
    excerpt: '作为重生萝莉岛中最受欢迎的伙伴角色，小樱以其温柔的性格和强大的治疗能力赢得了无数玩家的喜爱。',
    content: `<h2>角色档案</h2>
<p><strong>姓名：</strong>小樱<br/>
<strong>种族：</strong>治愈精灵族<br/>
<strong>年龄：</strong>外表14岁（实际年龄未知）<br/>
<strong>身高：</strong>152cm<br/>
<strong>生日：</strong>樱花盛开的季节<br/>
<strong>喜好：</strong>甜点、花朵、帮助他人</p>

<h2>背景故事</h2>
<p>小樱是治愈精灵族的最后一位公主。在千年前的<strong>暗影战争</strong>中，治愈精灵族几乎被完全消灭，只有年幼的小樱在长老们的保护下陷入了沉睡。当她醒来时，发现整个世界已经发生了翻天覆地的变化。</p>
<p>尽管经历了如此巨大的变故，小樱依然保持着善良温柔的本性。她选择留在重生萝莉岛上，用自己的治愈之力帮助每一位冒险者。</p>

<h2>技能介绍</h2>
<h3>主动技能：生命绽放</h3>
<p>小樱释放治愈光环，为全队恢复大量生命值。技能等级提升后，还能附加短暂的<strong>伤害减免</strong>效果。</p>

<h3>被动技能：天使守护</h3>
<p>当队友生命值低于30%时，小樱会自动为其施加一个<strong>护盾</strong>，持续8秒。这个被动技能在BOSS战中尤为关键。</p>

<h3>终极技能：樱花祈愿</h3>
<p>小樱召唤漫天樱花，对全体敌人造成伤害的同时，为全体队友恢复满生命值并清除所有负面状态。冷却时间较长，需要把握使用时机。</p>

<h2>羁绊剧情</h2>
<p>当与小樱的羁绊等级达到5级时，将解锁专属剧情<strong>"樱花树下的约定"</strong>。在这个剧情中，你将了解到小樱内心深处最柔软的秘密，以及她对未来的期望。这段剧情被玩家评为"重生萝莉岛最感人的故事"之一。</p>`,
    category: 'jiaose',
    categoryName: '角色图鉴',
    imageSeq: 'article-xiaoying',
    author: '图鉴编纂者小月',
    date: '2026-07-22',
    readTime: '12分钟',
    tags: ['小樱', '角色图鉴', '治愈精灵', '技能介绍', '羁绊剧情'],
  },
  {
    slug: 'xinghu-yiji-tanxian-riji',
    title: '冒险日志：星湖遗迹探险全记录',
    excerpt: '跟随我们的冒险者队伍，一起深入重生萝莉岛上最神秘的星湖遗迹，记录下这次惊心动魄的探险之旅。',
    content: `<h2>出发前的准备</h2>
<p>星湖遗迹位于重生萝莉岛的<strong>中央湖区</strong>，是岛上最神秘的古代遗迹之一。根据古籍记载，这里是古代魔法师进行星辰仪式的地方。出发前，我们准备了充足的治疗药水、照明道具以及解谜所需的魔法卷轴。</p>

<h2>遗迹第一层：星光大厅</h2>
<p>进入遗迹的第一瞬间，所有人都被眼前的景象震撼了。巨大的穹顶上镶嵌着无数发光的宝石，宛如夜空中的繁星。地面上铺设着复杂的<strong>星图纹路</strong>，只有按照正确的顺序踩踏才能开启通往下一层的通道。</p>

<h2>遗迹第二层：镜之水廊</h2>
<p>第二层是一个被水覆盖的长廊。水面如镜，倒映着天花板的星光。但这里隐藏着危险——水中潜伏着<strong>镜影怪物</strong>，它们能模仿队伍成员的外貌和技能。我们花费了不少时间才找到辨别真伪的方法。</p>

<h2>遗迹深处：星辰之核</h2>
<p>在遗迹的最深处，我们发现了传说中的<strong>星辰之核</strong>——一颗散发着柔和光芒的巨大水晶。据推测，这就是古代魔法师进行星辰仪式的核心装置。触碰水晶时，队伍中的每个人都感受到了一股温暖的能量涌入体内。</p>

<h2>探险收获</h2>
<p>这次星湖遗迹探险让我们获得了大量珍贵的<strong>古代遗物</strong>和稀有材料。更重要的是，我们解锁了新的重生点——以后从星湖遗迹出发探索周边区域会更加方便。强烈推荐各位冒险者在等级达到25级后前来挑战！</p>`,
    category: 'maoxian',
    categoryName: '冒险日志',
    imageSeq: 'article-xinghu',
    author: '冒险者阿星',
    date: '2026-07-20',
    readTime: '9分钟',
    tags: ['星湖遗迹', '探险记录', '古代遗迹', '冒险攻略'],
  },
  {
    slug: 'qihuan-shijie-sheding-quanjie',
    title: '重生萝莉岛奇幻世界观完全解读',
    excerpt: '从创世神话到魔法体系，带你全面了解重生萝莉岛庞大而精妙的奇幻世界观设定。',
    content: `<h2>创世神话</h2>
<p>在重生萝莉岛的古老传说中，世界是由<strong>七位原初精灵</strong>共同创造的。每位精灵掌管一种元素力量：火、水、风、土、光、暗，以及最神秘的第七元素——<strong>生命</strong>。</p>
<p>七位精灵创造了岛屿后，将自身的一部分力量融入了岛屿的核心。这就是重生萝莉岛拥有重生能力的原因——岛屿本身就是一个巨大的生命能量体。</p>

<h2>魔法体系</h2>
<p>重生萝莉岛的魔法体系分为六个等级：</p>
<ul>
<li><strong>学徒级：</strong>掌握基础元素操控，能够使用简单的攻击和防御魔法。</li>
<li><strong>精英级：</strong>能够结合两种元素施法，解锁复合魔法。</li>
<li><strong>大师级：</strong>精通单一元素，能够释放大范围强力魔法。</li>
<li><strong>贤者级：</strong>理解魔法本质，能够创造新的魔法咒语。</li>
<li><strong>传说级：</strong>与元素精灵建立契约，获得精灵的加护。</li>
<li><strong>神话级：</strong>触及世界本源，传闻能达到此境界的魔法师寥寥无几。</li>
</ul>

<h2>种族设定</h2>
<p>重生萝莉岛上生活着多个智慧种族：</p>
<p><strong>人类：</strong>最普遍的种族，适应性极强，在各方面都有均衡的潜力。</p>
<p><strong>精灵族：</strong>分为治愈精灵、森林精灵和暗夜精灵三个分支，天生拥有强大的魔法亲和力。</p>
<p><strong>兽耳族：</strong>拥有动物特征的可爱种族，以敏捷的身手和敏锐的感官著称。</p>
<p><strong>星灵族：</strong>据说是星辰的后裔，数量稀少但个体实力极其强大。</p>`,
    category: 'qihuan',
    categoryName: '奇幻设定',
    imageSeq: 'article-shijieguan',
    author: '设定考据党小灵',
    date: '2026-07-18',
    readTime: '15分钟',
    tags: ['世界观', '魔法体系', '种族设定', '创世神话', '深度解读'],
  },
  {
    slug: 'gaojie-zhandou-jiqiao',
    title: '高手进阶：重生萝莉岛战斗技巧全解析',
    excerpt: '想要在重生萝莉岛的战斗中脱颖而出？掌握这些高阶战斗技巧，让你成为岛屿上最强的冒险者。',
    content: `<h2>战斗系统核心机制</h2>
<p>重生萝莉岛的战斗系统看似简单，实则蕴含着丰富的策略深度。理解以下几个核心机制，是成为高手的第一步。</p>

<h3>元素克制链</h3>
<p>火克风、风克土、土克水、水克火，而光与暗相互克制。合理利用元素克制关系，能让你在战斗中事半功倍。</p>

<h3>连击系统</h3>
<p>连续攻击同一个敌人会积累<strong>连击槽</strong>。连击槽满后，下一次攻击将造成额外伤害并附带特殊效果。不同武器类型的连击效果各不相同。</p>

<h3>闪避反击</h3>
<p>在敌人攻击的瞬间进行闪避，会触发<strong>完美闪避</strong>效果，短时间内提升你的攻击力和暴击率。这是高手与普通玩家的分水岭。</p>

<h2>队伍搭配推荐</h2>
<p>一支平衡的队伍应该包含以下角色：</p>
<ul>
<li><strong>坦克位：</strong>负责吸引火力，保护后排（推荐：铁壁骑士艾琳）</li>
<li><strong>治疗位：</strong>保障队伍续航（推荐：治愈天使小樱）</li>
<li><strong>输出位：</strong>主力伤害来源（推荐：烈焰法师小焰 或 暗影刺客夜）</li>
<li><strong>辅助位：</strong>提供增益和控场（推荐：星辰术士露娜）</li>
</ul>`,
    category: 'gonglue',
    categoryName: '攻略指南',
    imageSeq: 'article-zhandou',
    author: '战斗大师阿铁',
    date: '2026-07-15',
    readTime: '11分钟',
    tags: ['战斗技巧', '高手进阶', '队伍搭配', '连击系统'],
  },
  {
    slug: 'an-ying-senlin-mi-mi',
    title: '剧情揭秘：暗影森林中隐藏的惊天秘密',
    excerpt: '暗影森林，重生萝莉岛上最危险的区域之一。但在其黑暗的表象之下，隐藏着一个关乎岛屿命运的惊天秘密。',
    content: `<h2>暗影森林的传闻</h2>
<p>暗影森林位于重生萝莉岛的<strong>东北部</strong>，是一片终年被浓雾笼罩的诡异森林。许多冒险者在此失踪，使得这片森林成为了岛上最令人畏惧的区域之一。但越是危险的地方，往往隐藏着越重要的秘密。</p>

<h2>深入调查</h2>
<p>经过长达三个月的调查，我们终于发现了暗影森林的真相。原来，这片森林并非天然形成，而是千年前<strong>暗影战争</strong>的遗址。当年七位原初精灵之一的<strong>暗之精灵</strong>在此与入侵者进行了最后的决战。</p>

<h2>惊人发现</h2>
<p>在森林最深处，我们找到了一座被封印的<strong>古代祭坛</strong>。祭坛上的铭文揭示了一个令人震惊的事实：暗之精灵并未消亡，而是将自己的灵魂封印在了祭坛之中，持续压制着一个更加强大的邪恶存在。</p>
<p>这个发现完全颠覆了我们对暗影森林的认知——它并非诅咒之地，而是一座<strong>守护之森</strong>。暗之精灵以永恒的牺牲，守护着整个岛屿的安全。</p>`,
    category: 'juqing',
    categoryName: '剧情解析',
    imageSeq: 'article-anying',
    author: '剧情研究员莉莉',
    date: '2026-07-12',
    readTime: '14分钟',
    tags: ['暗影森林', '剧情揭秘', '暗之精灵', '暗影战争', '隐藏剧情'],
  },
  {
    slug: 'quan-juese-shou-cang-zhi-nan',
    title: '全角色收集指南：如何招募所有伙伴',
    excerpt: '重生萝莉岛共有12位可招募的伙伴角色，本文为你详细列出每一位伙伴的招募条件和位置。',
    content: `<h2>伙伴招募总览</h2>
<p>重生萝莉岛目前共有<strong>12位</strong>可招募的伙伴角色，每位角色都有独特的招募条件和专属剧情。以下是完整指南：</p>

<h3>主线必得伙伴（4位）</h3>
<ul>
<li><strong>小樱（治愈精灵）：</strong>完成主线任务"启程之村"后自动加入。</li>
<li><strong>艾琳（铁壁骑士）：</strong>完成主线任务"古都废墟"后自动加入。</li>
<li><strong>小焰（烈焰法师）：</strong>完成主线任务"火焰山脉"后自动加入。</li>
<li><strong>露娜（星辰术士）：</strong>完成主线任务"星湖遗迹"后自动加入。</li>
</ul>

<h3>支线招募伙伴（5位）</h3>
<ul>
<li><strong>夜（暗影刺客）：</strong>在暗影森林深处找到隐藏洞穴，完成一系列潜行挑战。</li>
<li><strong>铃兰（风之弓手）：</strong>在翠绿森林的高塔顶部与她对话，需要先收集10个风之羽毛。</li>
<li><strong>小冰（冰雪女巫）：</strong>在北部雪原完成"冰封之心"系列任务。</li>
<li><strong>桃桃（兽耳战士）：</strong>在启程之村的酒馆参加大胃王比赛并获胜。</li>
<li><strong>星尘（星灵术士）：</strong>收集全部7颗星之碎片，在星辰祭坛召唤。</li>
</ul>

<h3>隐藏伙伴（3位）</h3>
<ul>
<li><strong>月（月之祭司）：</strong>在满月之夜前往月光湖畔触发隐藏剧情。</li>
<li><strong>花音（花之精灵）：</strong>在岛屿各处找到并浇灌9朵枯萎的魔法花。</li>
<li><strong>影（神秘旅人）：</strong>完成全部12位伙伴的羁绊剧情后，在启程之村触发最终隐藏剧情。</li>
</ul>`,
    category: 'jiaose',
    categoryName: '角色图鉴',
    imageSeq: 'article-jiaose',
    author: '图鉴编纂者小月',
    date: '2026-07-10',
    readTime: '13分钟',
    tags: ['伙伴收集', '全角色', '招募条件', '隐藏角色', '收集指南'],
  },
  {
    slug: 'jingyan-jiasu-shengji-jiqiao',
    title: '经验加速：7天快速升级到50级的秘诀',
    excerpt: '想在重生萝莉岛上快速提升等级？这篇经验加速攻略汇总了最高效的升级方法，助你7天冲击50级。',
    content: `<h2>升级总体规划</h2>
<p>想要在7天内达到50级，需要合理规划每天的冒险时间。以下是推荐的升级节奏：</p>

<h3>第1-2天：基础冲刺（目标1-20级）</h3>
<p>前两天专注于推进主线剧情。主线任务提供最丰厚的经验奖励，而且可以解锁重要的功能系统。记得在推进主线的同时，顺手完成路过的支线任务。</p>

<h3>第3-4天：副本刷级（目标20-35级）</h3>
<p>解锁<strong>翠绿森林副本</strong>后，这是前期最高效的刷级地点。组队刷副本可以获得组队经验加成，效率是单人刷级的1.5倍。</p>

<h3>第5-6天：委托任务（目标35-45级）</h3>
<p>每日委托任务是中期的经验主力。每天务必完成全部12个日常委托，同时留意委托板上的<strong>紧急委托</strong>——它们提供双倍经验奖励。</p>

<h3>第7天：冲刺50级</h3>
<p>最后一天使用之前积累的<strong>经验药水</strong>和<strong>双倍经验卷轴</strong>，前往古都废墟进行高强度刷怪。建议组满4人队伍，选择怪物密集的区域进行效率刷怪。</p>`,
    category: 'gonglue',
    categoryName: '攻略指南',
    imageSeq: 'article-shengji',
    author: '岛主小助手',
    date: '2026-07-08',
    readTime: '10分钟',
    tags: ['快速升级', '经验攻略', '等级冲刺', '新手进阶'],
  },
  {
    slug: 'huoban-qianghua-jiban-zhinan',
    title: '伙伴强化与羁绊系统深度指南',
    excerpt: '伙伴的强度不仅取决于等级，羁绊系统才是提升战斗力的关键。本文为你全面解析伙伴强化与羁绊系统。',
    content: `<h2>羁绊系统概述</h2>
<p>在重生萝莉岛中，每位伙伴都有独立的<strong>羁绊等级</strong>（1-10级）。提升羁绊等级不仅能解锁专属剧情，还能获得大量属性加成和特殊能力。</p>

<h2>提升羁绊的方法</h2>
<h3>日常互动</h3>
<p>每天与伙伴进行<strong>对话互动</strong>可以获得羁绊点数。每位伙伴每天最多互动3次，每次互动根据对话选项的不同，获得10-30点羁绊值。</p>

<h3>赠送礼物</h3>
<p>每位伙伴都有自己<strong>偏好的礼物</strong>。赠送偏好礼物可以获得双倍羁绊值。以下是部分伙伴的偏好：</p>
<ul>
<li>小樱：樱花糕点、治愈药剂</li>
<li>艾琳：精炼矿石、骑士小说</li>
<li>小焰：火焰结晶、辛辣料理</li>
<li>露娜：星尘碎片、古老书籍</li>
</ul>

<h3>并肩作战</h3>
<p>带着伙伴进行战斗是最自然的羁绊提升方式。每次战斗结束后，队伍中的伙伴都会获得少量羁绊值。难度越高的战斗，获得的羁绊值越多。</p>`,
    category: 'jiaose',
    categoryName: '角色图鉴',
    imageSeq: 'article-jiban',
    author: '图鉴编纂者小月',
    date: '2026-07-05',
    readTime: '12分钟',
    tags: ['羁绊系统', '伙伴强化', '好感度', '礼物偏好', '深度指南'],
  },
  {
    slug: 'daoju-cangku-guanli-jiqiao',
    title: '道具仓库管理：背包空间最大化利用技巧',
    excerpt: '背包空间总是不够用？掌握这些仓库管理技巧，让你的背包永远井井有条。',
    content: `<h2>背包扩容方法</h2>
<p>初始背包只有<strong>50个格子</strong>，对于重度玩家来说远远不够。以下是扩容的方法：</p>
<ul>
<li>完成仓库管理员支线任务：+10格</li>
<li>使用背包扩容卷轴：+5格/张（最多使用10张）</li>
<li>购买VIP特权：+20格</li>
<li>收集全套星之碎片：+15格</li>
</ul>
<p>全部解锁后，背包最大容量可达<strong>135格</strong>。</p>

<h2>道具分类管理</h2>
<p>建议按照以下优先级管理道具：</p>
<ol>
<li><strong>S级：</strong>稀有材料、限定道具——永远保留</li>
<li><strong>A级：</strong>高级消耗品、装备强化材料——保留到使用</li>
<li><strong>B级：</strong>普通材料、低级药水——定期清理</li>
<li><strong>C级：</strong>垃圾道具——立即出售或分解</li>
</ol>`,
    category: 'gonglue',
    categoryName: '攻略指南',
    imageSeq: 'article-cangku',
    author: '岛主小助手',
    date: '2026-07-02',
    readTime: '7分钟',
    tags: ['仓库管理', '背包技巧', '道具整理', '实用技巧'],
  },
  {
    slug: 'weilai-gengxin-yugao',
    title: '未来更新预告：新区域与新角色即将登场',
    excerpt: '开发团队公布了重生萝莉岛下半年的更新计划，包括全新区域、两位新伙伴以及多项系统优化。',
    content: `<h2>更新概览</h2>
<p>重生萝莉岛的开发团队在最近的直播中公布了<strong>2026年下半年</strong>的更新路线图，内容相当丰富，让我们一起来看看有哪些值得期待的内容。</p>

<h2>新区域：天空之城</h2>
<p>最令人兴奋的消息是全新区域——<strong>天空之城</strong>即将开放。这座漂浮在云层之上的古老城市，据说是星灵族的故乡。天空之城将带来全新的空中战斗机制和飞行坐骑系统。</p>

<h2>新伙伴：花音与月</h2>
<p>两位全新的伙伴角色将在接下来的更新中登场：</p>
<ul>
<li><strong>花音（花之精灵）：</strong>擅长范围治疗和植物系魔法，预计在8月更新中加入。</li>
<li><strong>月（月之祭司）：</strong>拥有强大的月相魔法，技能效果随游戏内昼夜变化，预计在10月更新中加入。</li>
</ul>

<h2>系统优化</h2>
<p>开发团队还宣布了多项系统优化计划，包括：背包搜索功能、自动战斗AI优化、以及全新的<strong>公会系统</strong>。公会系统的加入将让玩家之间的互动更加丰富。</p>`,
    category: 'qihuan',
    categoryName: '奇幻设定',
    imageSeq: 'article-gengxin',
    author: '前线记者小灵',
    date: '2026-06-28',
    readTime: '8分钟',
    tags: ['更新预告', '新区域', '新角色', '天空之城', '开发动态'],
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getRelatedArticles = (article: Article, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.slug !== article.slug && a.category === article.category)
    .slice(0, count);
};